import { useSelector } from "react-redux";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { DailogMain, SiteSettingModalContainer, TagsTitle } from "../MapStyled";
import { CircleBtn } from "assets/css/globle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

const COGAndTeeAndPOIEditPopup = ({
  sitesetupDialogBox,
  courseEditName,
  handleEditCourseChange,
  editHoleNo,
  setEditHoleNo,
  handleEditChange,
  holeCount,
  teeEditValue,
  teeEditHandleChange,
  cogDistan,
  modalState,
  poiEditTypeValue,
  poiEditHandleChange,
  poiEditPositionValue,
  poiEditPositionHandleChange,
  saveEditMarkers,
  editCogTeePoiSaveActiveButton,
  cancelDialogOpen,
  TeeMarkersDataState,
  setTeeMarkersDataState,
  editId,
  deleteId,
  siteId,
  setEditModel,
  PointsOfInterestDataState,
  setPointsOfInterestDataState
}) => {
  const { siteSettingsData, siteSetupData } = useSelector((state) => state.commonReducers) || [];

  const { t } = useTranslation();
  const dispatch = useDispatch();

  function deleteMarkers() {
    if (modalState === "tee") {
      let newDataTemp = JSON.parse(JSON.stringify(TeeMarkersDataState));

      let filterData =
        newDataTemp &&
        newDataTemp.length !== 0 &&
        newDataTemp.filter((el) => {
          return el?.Id !== Number(editId);
        });
      dispatch(COMMON_SERVICES.deleteTeeMarkerServices(deleteId, siteId)).then(()=>{
      setTeeMarkersDataState(filterData);
      });
      setEditModel(false);
    } else if (modalState === "poi") {
      let newDataTemp = JSON.parse(JSON.stringify(PointsOfInterestDataState));

      let filterData =
        newDataTemp &&
        newDataTemp.lenght !== 0 &&
        newDataTemp.filter((el) => {
          return el?.Id !== Number(editId);
        });

      setPointsOfInterestDataState(filterData);
      dispatch(COMMON_SERVICES.deletePoiMarkerServices(deleteId, siteId));
      setEditModel(false);
    }
    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId));
  }

  return (
    <DailogMain
      style={{
        position: `${sitesetupDialogBox.position}`,
        top: `${sitesetupDialogBox.top}`,
        left: `${sitesetupDialogBox.left}`,
      }}
    >
      <SiteSettingModalContainer>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {t("Edit_Site_Settings")}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>{t("Select_Course")}</DialogContentText>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={courseEditName}
              onChange={(e) => handleEditCourseChange(e)}
            >
              {siteSettingsData &&
                siteSettingsData?.Courses?.map((item) => (
                  <MenuItem key={item?.Number} value={item?.Number}>
                    {item?.Name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogContent>
          <DialogContentText>{t("Select_Hole")}</DialogContentText>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={editHoleNo}
              onChange={(e) => handleEditChange(e, setEditHoleNo)}
            >
              {holeCount !== null &&
                [...Array(holeCount)].map((elementInArray, index) => (
                  <MenuItem key={index + 1} value={index + 1}>{index + 1}</MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>

        {modalState === "tee" ? (
          <>
            <DialogContent>
              <DialogContentText>{t("Select_Tee")}</DialogContentText>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={teeEditValue}
                  defaultValue={teeEditValue}
                  onChange={(e) => teeEditHandleChange(e)}
                >
                  {siteSetupData.TeeMarkerSettings.map((item, i) => (
                    <MenuItem key={i} value={item.Id}>
                      {item.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            {cogDistan && <TagsTitle>Distance (CoG): {cogDistan} yd</TagsTitle>}
          </>
        ) : (
          <></>
        )}
        {modalState === "poi" ? (
          <DialogContent>
            <DialogContentText>{t("Select_Type")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={poiEditTypeValue}
                defaultValue={poiEditTypeValue}
                onChange={(e) => poiEditHandleChange(e)}
              >
                <MenuItem value={2}>{t("Hole")}</MenuItem>
                <MenuItem value={3}>{t("Approach")}</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
        ) : (
          <></>
        )}
        {modalState === "poi" ? (
          <DialogContent>
            <DialogContentText>{t("Select_Position")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={poiEditPositionValue}
                defaultValue={poiEditPositionValue}
                onChange={(e) => poiEditPositionHandleChange(e)}
              >
                <MenuItem value={0}>{t("Left")}</MenuItem>
                <MenuItem value={1}>{t("Right")}</MenuItem>
                <MenuItem value={2}>{t("Above")}</MenuItem>
                <MenuItem value={3}>{t("Below")}</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
        ) : (
          <></>
        )}
        <DialogActions>
          <CircleBtn
            onClick={() => {
              saveEditMarkers();
            }}
            className={editCogTeePoiSaveActiveButton ? "active" : "disabled"}
            disabled={!editCogTeePoiSaveActiveButton}
          >
            {t("Save")}
          </CircleBtn>
          <CircleBtn onClick={() => cancelDialogOpen("handleEditClose")}>
            {t("Cancel")}
          </CircleBtn>
          {modalState === "cog" ? null : (
            <CircleBtn
              onClick={() => {
                deleteMarkers();
              }}
            >
              {t("Delete")}
            </CircleBtn>
          )}
        </DialogActions>
      </SiteSettingModalContainer>
    </DailogMain>
  );
};

export default COGAndTeeAndPOIEditPopup;
